export default __webpack_public_path__ + "static/media/eth-diamond.6c33f4e5.png";